import { View } from 'foundations-components/components/View';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { LazyImageProvider } from 'trellis-ecosystem';
import { CollectionSection } from '../../components/CollectionSection';
import { SliderSection } from '../../components/SliderSection';
import { useCollectionApps } from '../../hooks/useCollectionApps';
import { AllSection } from './AllSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ProductHomeSections({
  error,
  featuredCollectionId,
  loading,
  productType,
  remainingSections,
  sections
}) {
  const {
    cards,
    collectionId,
    collectionSlug,
    description,
    hasValidCollectionData,
    title
  } = useCollectionApps(featuredCollectionId);
  if (loading) return /*#__PURE__*/_jsx(LoadingSpinner, {
    grow: true
  });
  if (error) return /*#__PURE__*/_jsx(ErrorMessage, {
    type: "badRequest"
  });
  return /*#__PURE__*/_jsx(LazyImageProvider, {
    children: /*#__PURE__*/_jsxs(View, {
      marginBlockStart: "1200",
      children: [sections === null || sections === void 0 ? void 0 : sections.map((section, index) => /*#__PURE__*/_jsx(SliderSection, {
        cards: section.cards,
        productType: productType,
        sectionIndex: index,
        sectionType: section.sectionType,
        title: section.title
      }, index)), (productType === 'APP' || productType === 'AGENT') && hasValidCollectionData && /*#__PURE__*/_jsx(CollectionSection, {
        cards: cards,
        collectionId: collectionId,
        collectionSlug: collectionSlug,
        description: description,
        productType: productType,
        sectionIndex: sections.length,
        title: title
      }), remainingSections === null || remainingSections === void 0 ? void 0 : remainingSections.map((section, index) => /*#__PURE__*/_jsx(SliderSection, {
        cards: section.cards,
        productType: productType,
        sectionIndex: sections.length + index + 1,
        sectionType: section.sectionType,
        title: section.title
      }, index)), /*#__PURE__*/_jsx(AllSection, {
        productType: productType,
        sectionIndex: sections.length + remainingSections.length + 2
      })]
    })
  });
}